import styled from "styled-components";

import { Grid } from "@mui/material";
import CustomLink from "../../components/CustomLink/CustomLink";
import Section5Bg from "../../assets/cangoo-home-fundo-parceiros.jpg"


export const StyledLink = styled(CustomLink)`
 text-decoration: none !important;
`;

export const Section1Grid = styled(Grid)`
background: ${({ theme }) => theme.COLORS.BACKGROUND_BLUE};
height: 100dvh;


padding-top: 14rem;
padding-left: 10rem;

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


.sideA {
animation: fadeIn 1s ease-in-out;
padding-top: 6rem;


@keyframes showLine {
  0% {
    height: 0; 
  }
  100% {
    height: 4rem; 
  }
}


@keyframes leftToRightAirplane {
  0% {
    transform: translateX(-50rem);
    opacity: 1;
  }
  96% {
    opacity: 1; 
  }
  100% {
    transform: translateX(110vw); 
    opacity: 0; 
    display: none;
  }
}

@keyframes leftToRight {
  0% {
    transform: translateX(-100vw);
    
  }
  100% {
    transform: translateX(0); 
  }
}

.aviao {
    position: absolute;
    left: -40rem;
    top: 32rem;
    animation: leftToRightAirplane 1.8s linear forwards;
    animation-delay: 0.3s;
    z-index: 99;

}


h2 {
    font-family: 'Mont-Medium';
    font-size: 4.4rem;
    color: ${({ theme }) => theme.COLORS.WHITE};
    letter-spacing: 1px;
}

h1 {
        font-size: 14rem; 
        font-family: 'Nexa-Black';
        letter-spacing: 1px;
        color: ${({ theme }) => theme.COLORS.YELLOW};
        line-height: 14rem;
        margin-left: -.8rem;
        margin-bottom: 6rem;

        animation: leftToRight 1.8s ease-out forwards;
        animation-delay: 0.1s;
    }


p {
    font-family: 'Mont-Medium';
    font-size: 3.4rem;
    color: ${({ theme }) => theme.COLORS.WHITE};

}


.yellow {
    color: ${({ theme }) => theme.COLORS.YELLOW};
    font-family: 'Mont-Bold';
}

.um {
    height: 0px;
    overflow: hidden;
    animation: showLine .6s forwards;
    animation-delay: 2s; 
}

.dois {
    height: 0px;
    overflow: hidden;
    animation: showLine .6s forwards;
    animation-delay: 2.6s;
}

.tres {
    height: 0px;
    overflow: hidden;
    animation: showLine .6s  forwards;
    animation-delay: 3.2s; 
}

.hide-container {
  height: 14rem;
}

.botao {
  margin-top: 5rem;
}


    .button {
    border: 1px solid ${({ theme }) => theme.COLORS.WHITE};
    border-radius: 999px;
    padding: 1rem 4rem;
    font-family: 'Mont-Bold';
    color: ${({ theme }) => theme.COLORS.WHITE};
    transition: all .2s;
    font-family: 'Mont-Medium';
    font-size: clamp(1.6rem, 3.4vw, 3rem); 

    &:hover {
        border: 1px solid ${({ theme }) => theme.COLORS.YELLOW};
        background-color: ${({ theme }) => theme.COLORS.YELLOW};
        color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
    }
  }


  .canguru-container {
  display: none;
}
}


.sideB {
animation: fadeIn .6s ease-in-out;
position: relative;


@keyframes float {
            0% {
                transform: translateY(0);
            }

            50% {
                transform: translateY(-20px);
            }

            100% {
                transform: translateY(0);
            }
      }


      @keyframes grow {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.06);
    }
    100% {
        transform: scale(1);
    }
}



.icone1 {
  position: absolute;
  bottom: 46rem;
  right: 54rem;
}

.bola1 {
   width: 30rem;
}

.IconeBola1 {
    position: absolute;
    width: 14rem;
    bottom: 8rem;
    right: 8rem;
    
    animation: grow 1s ease-in-out forwards;
    transform-origin: center;
}





.icone2 {
  position: absolute;
  right: 4rem;
  bottom: 47rem;
}

.bola2 {
    width: 20rem;
}

.IconeBola2 {
    animation: grow 1s ease-in-out forwards;
    transform-origin: center;
    position: absolute;
    bottom: 4.5rem;
    right: 4rem;
    width: 12rem;
}



.bola3 {
    position: absolute;
    bottom: 38rem;
    right: 80rem;
    width: 12rem;

}

.bola4 {
    position: absolute;
    bottom: 30rem;
    right: 18rem;
    width: 14rem;

}


.icone3 {
  position: absolute;
  bottom: 8rem;
  right: 70rem;
}

.bola5 {
    width: 24rem;
}

.IconeBola5 {
    animation: grow 1s ease-in-out forwards;
    transform-origin: center;
    position: absolute;
    width: 18rem;
    right: 3.5rem;
    bottom: 7rem;
     
}



.bola6 { 
    position: absolute;
    bottom: 8rem;
    right: 8rem;
    width: 10rem;

}


.canguru-container {
    animation: float 3s ease-in-out infinite;
    position: absolute;
    right: 6rem;
    bottom: -3rem;
}

.canguru {
   
    width: 72rem;
    animation: grow 1s ease-in-out forwards;
}
}



@media (max-width: 1600px) {
  padding-left: 6rem;

  .sideA {
padding-top: 3rem;


@keyframes showLine {
  0% {
    height: 0; 
  }
  100% {
    height: 3.4rem; 
  }
}

.aviao {
    top: 27rem;
    animation: leftToRightAirplane 1.7s linear forwards;
    width: 30rem;
}


  h2 {
    font-size: 4rem;   
}

h1 {
        line-height: 10rem;
        margin-bottom: 4rem;
        margin-left: -.2rem;
        animation-delay: 0s;
        font-size: 10rem;
    }

p {
    font-size: 3rem;
}


.hide-container {
  height: 10rem;
}

.botao {
  margin-top: 5rem;
}

    .button {
    padding: 1rem 4rem;
    font-size: 3rem; 
  }
}



  .sideB {
    .icone1 {
  bottom: 35rem;
  right: 42rem;
}

.bola1 {
   width: 20rem;
}

.IconeBola1 {
    width: 10rem;
    bottom: 4.5rem;
    right: 4.5rem;    
}

.icone2 {
  right: 4rem;
  bottom: 36rem;
}

.bola2 {
    width: 14rem;
}

.IconeBola2 {
    bottom: 3.5rem;
    right: 3.5rem;
    width: 7rem;
}

.bola3 {
    bottom: 30rem;
    right: 57rem;
    width: 5rem;
}

.bola4 {
    bottom: 24rem;
    right: 16rem;
    width: 8rem;
}

.icone3 {
  bottom: 6rem;
  right: 56rem;
}

.bola5 {
    width: 16rem;
}

.IconeBola5 {
    width: 10rem;
    right: 3rem;
    bottom: 5.2rem;    
}

.bola6 { 
    bottom: 6.4rem;
    right: 12rem;
    width: 5rem;
}

    .canguru {   
   width: 55rem;
} 
  }


}



@media (max-width: 1400px) {
  padding-left: 6rem;

.sideA {
padding-top: 0;


@keyframes showLine {
0% {
  height: 0; 
}
100% {
  height: 3rem; 
}
}

.aviao {
  top: 22rem;
  animation: leftToRightAirplane 1.7s linear forwards;
  width: 26rem;
}


h2 {
  font-size: 3.4rem;   
}

h1 {
      line-height: 8rem;
      margin-bottom: 3rem;
      margin-left: -.2rem;
      animation-delay: 0s;
      font-size: 8rem;
  }

p {
  font-size: 2.6rem;
}


.hide-container {
height: 10rem;
}

.botao {
margin-top: 3rem;
}

  .button {
  padding: 1rem 4rem;
  font-size: 2.4rem; 
}
}



  .sideB {
    .icone1 {
  bottom: 29rem;
  right: 36rem;
}

.bola1 {
   width: 16rem;
}

.IconeBola1 {
    width: 8rem;
    bottom: 4rem;
    right: 4rem;    
}

.icone2 {
  right: 4rem;
  bottom: 29rem;
}

.bola2 {
    width: 12rem;
}

.IconeBola2 {
    bottom: 3rem;
    right: 3rem;
    width: 6rem;
}

.bola3 {
    bottom: 25rem;
    right: 50rem;
    width: 5rem;
}

.bola4 {
    bottom: 20rem;
    right: 15rem;
    width: 7rem;
}

.icone3 {
  bottom: 6rem;
  right: 47rem;
}

.bola5 {
    width: 14rem;
}

.IconeBola5 {
    width: 9rem;
    right: 3rem;
    bottom: 4.5rem;    
}

.bola6 { 
    bottom: 4rem;
    right: 10rem;
    width: 5rem;
}

    .canguru {   
   width: 45rem;
} 
  }


}


@media (max-width: 1100px) {
  padding-left: 6rem;

  .sideA {
padding-top: 0rem;


@keyframes showLine {
  0% {
    height: 0; 
  }
  100% {
    height: 2.4rem; 
  }
}

.aviao {
    top: 18rem;
    animation: leftToRightAirplane 1.7s linear forwards;
    width: 24rem;
}


  h2 {
    font-size: 2.2rem;   
}

h1 {
        line-height: 6rem;
        margin-bottom: 2rem;
        margin-left: -.2rem;
        animation-delay: 0s;
        font-size: 6rem;
    }

p {
    font-size: 2rem;
}


.hide-container {
  height: 10rem;
}

.botao {
  margin-top: 2rem;
}

    .button {
    padding: 1rem 4rem;
    font-size: 2rem; 
  }
}



  .sideB {
    .icone1 {
  bottom: 24rem;
  right: 30rem;
}

.bola1 {
   width: 16rem;
}

.IconeBola1 {
    width: 8rem;
    bottom: 4rem;
    right: 4rem;    
}

.icone2 {
  right: 4rem;
  bottom: 23rem;
}

.bola2 {
    width: 12rem;
}

.IconeBola2 {
    bottom: 3rem;
    right: 3rem;
    width: 6rem;
}

.bola3 {
    bottom: 20rem;
    right: 44rem;
    width: 5rem;
}

.bola4 {
    bottom: 15rem;
    right: 13rem;
    width: 7rem;
}

.icone3 {
  bottom: 3rem;
  right: 40rem;
}

.bola5 {
    width: 14rem;
}

.IconeBola5 {
    width: 9rem;
    right: 3rem;
    bottom: 4.5rem;    
}

.bola6 { 
    bottom: 4rem;
    right: 8rem;
    width: 5rem;
}

    .canguru {   
   width: 38rem;
} 
  }


}


@media (max-width: 900px) {
padding-left: 2rem;
padding-right: 1rem;

   .sideA { 
    position: relative;

    @keyframes leftToRightAirplane {
  0% {
    transform: translateX(-50rem);
    opacity: 1;
  }

  99% {
    opacity: 1; 
  }

  100% {
    transform: translateX(120vw); 
    opacity: 0; 
    display: none;
  }
}

    @keyframes float {
            0% {
                transform: translateY(0);
            }

            50% {
                transform: translateY(-20px);
            }

            100% {
                transform: translateY(0);
            }
      }


      @keyframes grow {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.06);
    }
    100% {
        transform: scale(1);
    }
}


    .canguru-container {
      display: inherit;
      animation: float 3s ease-in-out infinite;
      position: absolute;
      right: 2rem;
      top: 0;

}

.canguru {
    width: clamp(18rem, 35vw, 35rem);    
    animation: grow 1s ease-in-out forwards;
}

.aviao {
    top: 7rem;
    width: 20rem;
    animation: leftToRightAirplane 1.6s linear forwards;
}

h1 {
        line-height: 8rem;
        margin-bottom: 2rem;
        margin-left: -.4rem;
    }


    .button {
    bottom: 20rem;
  }


   }

  .sideB {
    display: none;
  }
}


@media (max-width: 600px) {
   .sideA { 
    position: relative;
    padding-top: 4rem;

    @keyframes leftToRightAirplane {
  0% {
    transform: translateX(-50rem);
    opacity: 1;
  }


  100% {
    transform: translateX(200vw); 
    opacity: 1; 
    display: none;
  }
}

    @keyframes float {
            0% {
                transform: translateY(0);
            }

            50% {
                transform: translateY(-20px);
            }

            100% {
                transform: translateY(0);
            }
      }


      @keyframes grow {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.06);
    }
    100% {
        transform: scale(1);
    }
}


    .canguru-container {
      top: 8rem;
}


.aviao {
    top: 11rem;
    width: 15rem;
    animation: leftToRightAirplane 2.2s linear forwards;
}


h1 {
  transform: translateX(-100%);

        animation-delay: 0.3s;
    }


    .button {
    bottom: 15rem;
    left: 50%;
    transform: translate(-50%);
    font-size: 1.4rem;
    padding: 1rem 2rem;
  }
   }
}


@media (max-width: 450px) {
  padding-left: 1rem;
  padding-right: 1rem;
.sideA {
  text-align: center;
  padding-top: 0;

  .aviao {
    top: 6.5rem;
    width: 15rem;
    animation: leftToRightAirplane 2.4s linear forwards;
}


h1 {
  animation: leftToRight 2.4s ease-out forwards;
  transform: translateX(-100%);
  line-height: 6rem;
  animation-delay: 1s;
    }


    .botao {
      margin-top: 4rem;
    }


  .button {
    position: sticky;
      bottom: 0;
      left: auto; 
      transform: none; 
      font-size: 1.4rem;
      padding: 1rem 4rem;
      font-size: clamp(1.6rem, 3.4vw, 2rem); 
  }


  .canguru-container {
    position: sticky;
    margin-top: 6rem;
}


.hide-container {
  height: 7.2rem;
}
}
}
`;


export const Section2Grid = styled(Grid)`
padding-top: 20rem;

.card {
    background-color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: relative;

    width: 36rem;
    padding-top: 12rem;
    padding-bottom: 8rem;
    padding-left: 2rem;
    padding-right: 2rem;
    transition: all .4s;
    

    p {
    font-family: 'Mont-Bold';
    font-size: clamp(1.6rem, 3.4vw, 3rem);
    color: ${({ theme }) => theme.COLORS.WHITE};
  }

  img {
    position: absolute;
    top: -12rem;

    width: 20rem;
  }

  &:hover {
    scale: 1.1;
  }

}


.sideA, .sideB, .sideC {
    display: flex;
    justify-content: center;
}


@media (max-width: 1400px) {

  .card {
    width: 28rem;

    p {
      font-size: clamp(1.6rem, 3.4vw, 2.4rem);
    }

    img {
    top: -7rem;
    width: 14rem;
  }
  }
}


@media (max-width: 1000px) {
  padding-top: 14rem;

.card {
  width: 24rem;

  p {
    font-size: 2rem;
  }

  img {
  top: -6rem;
  width: 12rem;
}
}
}

@media (max-width: 900px) {
  justify-content: center;

 .sideB, .sideC {
   margin-top: 10rem;
}

.card {
  width: 24rem;
  padding-top: 10rem;
  padding-bottom: 7rem;

  p {
    font-size: 2rem;
  }

  img {
  top: -6rem;
  width: 12rem;
}
}
}


`;

export const Section3Grid = styled(Grid)`
padding: 10rem 0;
padding-right: 6rem;

.sideA {
    img {
        width: clamp(30rem, 44vw, 86rem); 
    }
}


.sideB {

    h1 {
        font-size: clamp(4rem, 7vw, 14rem); 
        font-family: 'Nexa-Bold';
        letter-spacing: 1px;
        color: ${({ theme }) => theme.COLORS.YELLOW};
        line-height: 12rem;
    }

    h2 {
        font-size: clamp(2.4rem, 4vw, 8rem); 
        font-family: 'Nexa-Bold';
        letter-spacing: 1px;
        color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
        line-height: 8rem;
  }

    p {
    font-family: 'Mont-Light';
    font-size: clamp(1.6rem, 3.4vw, 3rem); 
    color: ${({ theme }) => theme.COLORS.BLUE};
    margin-top: 4rem;
    margin-bottom: 6rem;
  }

  span {
    font-family: 'Mont-Medium';
    font-size: clamp(1.6rem, 3.4vw, 3rem); 
  }

  .yellow {
    color: ${({ theme }) => theme.COLORS.YELLOW};
  }

  .button {
    border: 1px solid ${({ theme }) => theme.COLORS.LIGHTBLUE2};
    border-radius: 999px;
    padding: 1rem 4rem;
    font-family: 'Mont-Bold';
    color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
    transition: all .2s;

    &:hover {
        border: 1px solid ${({ theme }) => theme.COLORS.YELLOW};
        background-color: ${({ theme }) => theme.COLORS.YELLOW};
    }
  }
}


@media (max-width: 1400px) {

  .sideB {
    h1 {
        font-size: clamp(5rem, 5vw, 8rem); 
        line-height: clamp(2rem, 3.5vw, 8rem); 
    }

    h2 {
        font-size: clamp(2.6rem, 3.4vw, 5rem);
    }

    p {
      margin-top: 2rem;
    }

    p, span {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem); 
    }
  }
}


@media (max-width: 1200px) {
  .sideA {
    display: flex;
    align-items: center;
  }
}


@media (max-width: 900px) {
padding-left: 2rem;
padding-right: 2rem;

.sideA {
  display: none;
}

.sideB {
  text-align: center;
}
}
`;

export const VantagensTitle = styled.div`
background: ${({ theme }) => theme.COLORS.BACKGROUND_BLUE};
text-align: center;
padding: 6rem 2rem;

h1 {
        font-family: 'Mont-Medium';
        font-size: clamp(2.6rem, 3.4vw, 5rem);
        color: ${({ theme }) => theme.COLORS.WHITE};
        letter-spacing: 1px;
    }


    @media (max-width: 1500px) {
      padding: 3rem 2rem;

      h1 {
        font-size: clamp(2rem, 3.4vw, 3.4rem);
      }
    }
`;


export const Section4Grid = styled(Grid)`
padding:10rem 20rem;

h1 {
        font-size: clamp(2.4rem, 4vw, 8rem); 
        font-family: 'Nexa-Bold';
        letter-spacing: 1px;
        color: ${({ theme }) => theme.COLORS.LIGHTBLUE2};
  }

  p {
    font-family: 'Mont-Light';
    font-size: clamp(1.6rem, 3.4vw, 3rem); 
    color: ${({ theme }) => theme.COLORS.BLUE};
    margin-top: 4rem;
  }



  @media (max-width: 1400px) {
    padding:10rem 16rem;

    h1 {
        font-size: clamp(2.6rem, 3.4vw, 5rem);
    }

    p {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem); 
    }
}


@media (max-width: 1200px) {
  padding:10rem 10rem;
}

@media (max-width: 900px) {
  padding:10rem 2rem;
  text-align: center;
}

@media (max-width: 600px) {
    padding:6rem 2rem;
}

`;

export const Section5Grid = styled(Grid)`
padding: 6rem 0;

background: url(${Section5Bg});
background-repeat: no-repeat;
background-position: top left; 
background-size: cover; 

.sideA {
    padding-left: 12rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    color: ${({ theme }) => theme.COLORS.WHITE};

    h1 {
        font-family: 'Mont-Medium';
        font-size: clamp(2.6rem, 3.4vw, 5rem);
        letter-spacing: 1px;
        margin: 4rem 0;
    }

    span {
        font-family: 'Nexa-Black';
        color: ${({ theme }) => theme.COLORS.YELLOW};
        font-size: clamp(2.4rem, 8vw, 15rem);
        line-height: 15rem;
        letter-spacing: 1px;
    }

    p {
   
    font-family: 'Mont-Light';
    font-size: clamp(1.6rem, 3.4vw, 3rem); 
    }
}

.sideB {
    img {
        width: clamp(30rem, 48vw, 90rem); 
    }
}


@media (max-width: 1400px) {
    .sideA {
    padding-left: 8rem;

    h1 {
        font-size: clamp(2.6rem, 3.4vw, 4rem);
    }


    span {
        font-size: clamp(4rem, 6vw, 10rem);
        line-height: clamp(4rem, 6vw, 10rem);
    }

    p {
        font-size: clamp(1.8rem, 3.4vw, 2.2rem); 
    }
    }
}

@media (max-width: 1100px) {
    .sideA {
    padding-left: 4rem;
    }
}


@media (max-width: 900px) {
    padding: 6rem 4rem;

    .sideA {
    padding-left: 0;

    h1 {
        margin-top: 0;
    }

    p {
        margin-bottom: 4rem;
    }
    }

    .sideB {
        text-align: center;
    }
}

@media (max-width: 600px) {
    padding: 6rem 2rem;
}


`;
